"use client";

import React from "react";
import { motion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const badges = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/award_winning_badge.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/award_winning_badge.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/award_winning_badge.png-wvc-sizes",
  alt: "Award Winning Service"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/yelp_reviews_badge.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/yelp_reviews_badge.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/yelp_reviews_badge.png-wvc-sizes",
  alt: "Yelp 5 Star Reviews"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/google_reviews_badge.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/google_reviews_badge.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/google_reviews_badge.png-wvc-sizes",
  alt: "Google 5 Star Reviews"
}];
export default function CompanyOverviewSEO() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: badgesRef,
    isVisible: areBadgesVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="companyoverviewseo" className="text-foreground overflow-hidden !bg-[hsl(24,10%,10%)]">
      {}
      

      {}
      

      {}
      <div className="relative bg-secondary py-16 md:py-24">
        {}
        <div className="absolute inset-0 z-0">
          <div className="absolute inset-0 mix-blend-multiply z-10 h-full w-full object-cover Image Jun 26, 2026, 02_02_52 AM.png)] !bg-[hsl(213,94%,68%)]"></div>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/global_network_bg.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/global_network_bg.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/global_network_bg.png-wvc-sizes" alt="Global Transportation Network" className="h-full w-full object-cover opacity-40" loading="lazy" />
        </div>

        {}
        <motion.div ref={ctaRef} initial={{
        opacity: 0,
        y: 30
      }} animate={isCtaVisible ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.7,
        ease: "easeOut"
      }} className="relative z-20 mx-auto max-w-4xl px-6 text-center">
          <h2 className="mb-4 font-display text-2xl font-bold tracking-tight text-white md:text-5xl">
            PREMIUM TRANSPORTATION SERVICES
          </h2>
          <p className="mb-10 font-sans text-base uppercase tracking-widest text-white/90 md:text-xl">
            Serving Los Angeles & Surrounding Areas
          </p>
          
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Button asChild variant="default" size="lg" className="min-w-[160px]">
              <Link to="/ContactPage">Contact Us</Link>
            </Button>
            <Button asChild variant="default" size="lg" className="min-w-[160px]">
              <Link to="/ReservationsPage">Request a Quote</Link>
            </Button>
            <Button asChild variant="default" size="lg" className="min-w-[160px]">
              <Link to="/ReservationsPage">Book Online</Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}